import React, { useMemo } from "react";
import { Box, Button, Typography } from "@mui/material";
import ViewerHeader from "./ViewerHeader";
import LoadingSequence from "./LoadingSequence";
import { useLocalization } from "../localization/LocalizationContext";

const AUTH_LOADING_SYSTEM = {
  name: "3D viewer",
  environments: [],
};

const ViewerSessionStatusScreen = ({
  actionLabel,
  detail,
  loading = false,
  onAction,
  role = loading ? "status" : "alert",
  title,
}) => {
  const { t } = useLocalization();
  const sequenceSystem = useMemo(() => AUTH_LOADING_SYSTEM, []);

  return (
    <div className="App">
      <div className="content">
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "radial-gradient(circle at top left, rgba(39, 94, 107, 0.25) 0%, rgba(9, 15, 23, 0) 36%), linear-gradient(180deg, #060b10 0%, #0c141d 100%)",
          }}
        />
        <ViewerHeader system={null} />
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: 3,
          }}
        >
          <Box
            aria-label={loading ? title : undefined}
            role={role}
            sx={{
              width: "100%",
              maxWidth: 520,
              textAlign: "center",
              p: { xs: 3, sm: 4 },
              borderRadius: "14px",
              border: "1px solid rgba(255,255,255,0.08)",
              background:
                "linear-gradient(180deg, rgba(15, 23, 34, 0.96) 0%, rgba(10, 16, 24, 0.98) 100%)",
              boxShadow: "0 32px 80px rgba(0, 0, 0, 0.35)",
            }}
          >
            <Typography
              variant="overline"
              sx={{ color: "rgba(255,255,255,0.64)", letterSpacing: "0.14em" }}
            >
              {t("loading.viewer")}
            </Typography>
            <Typography variant="h5" sx={{ mt: 1, color: "#fff" }}>
              {title}
            </Typography>
            {detail && (
              <Typography sx={{ mt: 1.5, color: "rgba(255,255,255,0.72)" }}>
                {detail}
              </Typography>
            )}
            {loading && (
              <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
                <LoadingSequence
                  delay={650}
                  onComplete={null}
                  systemData={sequenceSystem}
                />
              </Box>
            )}
            {onAction && actionLabel && (
              <Button
                type="button"
                onClick={onAction}
                variant="contained"
                sx={{
                  mt: 3,
                  backgroundColor: "rgba(46, 160, 196, 0.92)",
                  color: "#fff",
                  fontWeight: 700,
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "rgba(59, 183, 220, 0.96)",
                  },
                }}
              >
                {actionLabel}
              </Button>
            )}
          </Box>
        </Box>
      </div>
    </div>
  );
};

export default ViewerSessionStatusScreen;
